module.exports = __webpack_public_path__ + "static/media/xz_btn.0619ac17.png";